import { apiPathFunc } from "@api/util/apiPathFunc";
import type { IExtractParams } from "@/routes";

const pathBase = `/users/set_current_user_password/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const setPassword = {
  post: apiPathFunc(pathBase),
};
